export default __webpack_public_path__ + "static/media/discontent.466b5547.svg";